//@ts-nocheck
import Vue from "vue";
import {install} from "vue-moment"

Vue.use(install);